/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import {
  MotifModal,
  MotifModalHeader,
  MotifModalBody,
  MotifTheme,
  MotifModalFooter,
  MotifButton,
  MotifIcon,
  MotifTooltip,
} from "@ey-xd/motif-react";
import { IconoirDownload } from "@ey-xd/motif-icon";
import "../CreateSku/CreateSkuModal.scss";
import "../CreateSku/UpdateSkuModal.scss";
import "./PreviewSkuModal.scss";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { useParams } from "react-router";
import { fetchSkuConfigData } from "../../store/slices/CTDBSkuConfigSlice";
import {
  AUTO_PROVISION,
  COST_INTERVAL,
  COMMERCIAL_PLACEHOLDER,
  COMMERCIAL_STATUS,
  COST,
  COST_CATEGORY,
  COST_CATEGORY_PLACEHOLDER,
  COST_MACRO_CATEGORY,
  EMPIRE_CODE_PLACEHOLDER,
  MINIMUM_SELECTABLE_INCREMENT,
  RETURNABLE,
  SKU_LONG_DESCRIPTION,
  SKU_NAME,
  SKU_RELATION,
  COST_METRIC,
  COST_METRIC_PLACEHOLDER,
  NSR,
  BILLING_TYPE_STATUS,
  INDEXATION,
  CFO_APPROVAL,
  NO_CFO_APPROVAL,
} from "../CreateSku/Constants";
import Loader from "../../components/Loader";
import {
  getSkuDetails,
  fetchSKUArtifactFileData,
} from "../../store/slices/CTDBCreateSkuSlice";
import NotificationGrid from "../../components/Notification/NotificationGrid";
import { fetchSkuListAllData } from "../../store/slices/CTDBSkuListAllSlice";
import {
  PROVISIONING_TEAM,
  GLOBAL_RISK_MANAGER,
  LOCAL_RISK_MANAGER,
  ORDER_ACKNOWLEDGEMENT,
  PRODUCT_APPROVER,
  CONSUMPTION_MANAGER,
} from "../../Constant";
import {
  formatUSDWithCommas,
  getArtifactFileName,
  formattingBytes,
  truncateString,
} from "../../utils/common";
import { downloadArtifactFile } from "../CreateSku/helper";

interface ProxyOwner {
  Name: string;
  Email: string;
}
export default function PreviewSkuModal({
  show = true,
  setShow,
  selectedSku,
  isConsumptionManager = false,
}: {
  show: boolean;
  setShow: (isVisible: boolean) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSave?: (updatedComment: any) => void;
  selectedSku?: string;
  isConsumptionManager?: boolean;
}) {
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [show]);

  const [localRiskMng, setLocalRiskMng] = useState<string>("");
  const [globalRiskMng, setGlobalRiskMng] = useState<string>("");
  const [productApproverList, setProductApproverList] = useState<string>("");
  const [consumptionManagerList, setConsumptionManagerList] =
    useState<string>("");
  const [deploymentApproverList, setDeploymentApproverList] =
    useState<string>("");
  const [artifactPreviewError, setArtifactPreviewError] = useState<string>("");
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [getSKUData, setGetSkuData] = useState<null | any>(null);
  const param = useParams();

  const dispatch = useDispatch<AppDispatch>();

  const isconfigLoadingAPi = useSelector(
    (state: RootState) => state.CTDBSkuConfigSlice.isLoading,
  );
  const configData = useSelector(
    (state: RootState) => state.CTDBSkuConfigSlice.data,
  );
  const configErrorAPi = useSelector(
    (state: RootState) => state.CTDBSkuConfigSlice.error,
  );

  const isSkuListLoadingAPi = useSelector(
    (state: RootState) => state.CTDBSkuListAllSlice.isLoading,
  );

  const skuListErrorAPi = useSelector(
    (state: RootState) => state.CTDBSkuListAllSlice.error,
  );

  const createSKUErrorAPi = useSelector(
    (state: RootState) => state.CTDBCreateSkuSlice.error,
  );

  const getSKUIsLoadingAPi = useSelector(
    (state: RootState) => state.CTDBCreateSkuSlice.isLoadingDetails,
  );

  const getSKUErrorAPi = useSelector(
    (state: RootState) => state.CTDBCreateSkuSlice.errorDetails,
  );

  const initialValues = {
    skuShortDescription: "",
    skuLongDescription: "",
    costCategory: "",
    chargingIncrement: "",
    returnable: null,
    costMacroCategory: "",
    minimumSelectableIncrement: null,
    cost: null,
    skuRelation: [],
    autoProvision: null,
    commercialStatus: "",
    costMetric: "",
    CostMetricNSR: null,
    billingType: "",
  };

  const currentSku = selectedSku;

  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [show]);

  useEffect(() => {
    dispatch(
      fetchSkuListAllData({
        search: "",
        productId: param.id || "", // Replace with actual product ID
        page: 1,
        record: 1000,
        sortOrder: "desc",
        sortColumn: "SkuId",
        exclude: "AutoTransact",
      }),
    );
  }, [dispatch, param.id]);

  const getEmailList = (userList: ProxyOwner[]) => {
    if (!userList || userList.length === 0) {
      return "-";
    }
    const emails = userList.map((user) => user.Email).join(", ");
    return emails;
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [formFields, setFormFields] = useState<any>(initialValues);

  useEffect(() => {
    if (param.id !== undefined && param.id !== null && configData === null) {
      dispatch(fetchSkuConfigData());
    }
  }, [param.id, configData]);

  useEffect(() => {
    if (param.id !== undefined && param.id !== null) {
      if (currentSku && currentSku !== "") {
        async function fetchSkuDetails() {
          const skuDetailsFetch = await dispatch(
            getSkuDetails({
              ProductId: param.id,
              SkuId: currentSku,
            }),
          );
          setGetSkuData(skuDetailsFetch.payload.Data[0]);
        }
        fetchSkuDetails();
      }
    }
  }, [currentSku, show]);

  const {
    skuShortDescription,
    skuLongDescription,
    costCategory,
    chargingIncrement,
    returnable,
    costMacroCategory,
    minimumSelectableIncrement,
    cost,
    skuRelation,
    autoProvision,
    commercialStatus,
    costMetric,
    CostMetricNSR,
    billingType,
    Indexation,
  } = formFields;

  const setValueZeroOrOne = (value: boolean | null) => {
    if (value === null) {
      return null;
    }
    return value ? "1" : "0";
  };

  const setValueYesOrNo = (value: string | null) => {
    if (value === null) {
      return null;
    }
    return value === "1" ? "Yes" : "No";
  };

  const CostCategoryTypeOptions: { label: string; value: string }[] = [
    {
      label: COST_CATEGORY_PLACEHOLDER,
      value: "",
    },
  ];

  const CostMetricOptions: { label: string; value: string }[] = [
    {
      label: COST_METRIC_PLACEHOLDER,
      value: "",
    },
  ];
  let CommercialStatusOptions: { label: string; value: string }[] = [
    {
      label: COMMERCIAL_PLACEHOLDER,
      value: "",
    },
  ];
  let CostMacroCategoryOptions: { label: string; value: string }[] = [];
  let ChargingIncrementOptions: { label: string; value: string }[] = [];
  let BillingTypeOptions: { label: string; value: string }[] = [];
  if (configData === null) {
    console.log("configData is null");
  } else {
    const {
      CostCategory,
      CommercialStatus,
      CostMacroCategory,
      ChargingIncrement,
    } = configData;

    const uniqueCostCategory: string[] = [];
    CostCategory?.forEach(
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      (item: {
        Name: string;
        CostMetricType: string;
        CostMetricCd: string;
        CostMetric: string;
      }) => {
        CostMetricOptions.push({
          label: item.CostMetric,
          value: item.CostMetric,
        });
        if (uniqueCostCategory.includes(item.CostMetricType) === false) {
          uniqueCostCategory.push(item.CostMetricType);
          CostCategoryTypeOptions.push({
            label: item.CostMetricType,
            value: item.CostMetricType,
          });
        }
      },
    );
    const CommercialStatusFilter = CommercialStatus?.filter(
      (item: { Name: string; StatusCd: string; StatusType: string }) =>
        item.StatusType === "sku",
    );

    CommercialStatusOptions = CommercialStatusFilter?.map(
      (item: { Name: string; StatusCd: string }) => ({
        label: item.Name,
        value: item.StatusCd,
      }),
    );
    const billingTypeFilter = CommercialStatus?.filter(
      (item: { Name: string; StatusCd: string; StatusType: string }) =>
        item.StatusType === "skubill",
    );

    BillingTypeOptions =
      billingTypeFilter?.map((item: { Name: string; StatusCd: string }) => ({
        label: item.Name,
        value: item.StatusCd,
      })) || [];
    CostMacroCategoryOptions = CostMacroCategory?.map(
      (item: { Name: string; CostMacroCategoryCd: string }) => ({
        label: item.Name,
        value: item.CostMacroCategoryCd,
      }),
    );
    ChargingIncrementOptions = ChargingIncrement?.map(
      (item: { Name: string; CostIntervalCd: string }) => ({
        label: item.Name,
        value: item.CostIntervalCd,
      }),
    );
  }

  const validateDecimalValue = (amt: any) => {
    if (amt === null || amt === undefined) {
      return "";
    }
    amt = String(amt);
    if (
      formatUSDWithCommas(amt).length > 0 &&
      formatUSDWithCommas(amt).length < 9
    ) {
      if (!amt.includes(".")) {
        // If no dot, append .00
        amt = amt + ".00";
      } else {
        const [intPart, decPart] = amt.split(".");
        const newInt = intPart || "0";
        const newDec = decPart.padEnd(2, "0").slice(0, 2); // Fill zeros if needed
        amt = newInt + "." + newDec;
      }
    }
    return amt;
  };

  useEffect(() => {
    if (getSKUData && getSKUData !== null && configData !== null) {
      const skuRelationSelected = Array.isArray(getSKUData?.SkuRelation)
        ? (
            getSKUData.SkuRelation as unknown as {
              Name: string;
              Status: string;
            }[]
          )
            .filter(
              (item) =>
                item.Status !== "sku_retired" && item.Status !== "sku_rejected",
            )
            .map((item) => item.Name)
        : [];

      const commercialStatus = CommercialStatusOptions?.find(
        (item) => item.label === getSKUData?.StatusCd,
      );
      const selectedCostCategory = configData?.CostCategory?.find(
        (item: {
          CostMetricType: string;
          CostMetricCd: string;
          Name: string;
        }) => item.CostMetricCd === getSKUData?.CostMetricCd,
      );
      setFormFields(() => {
        return {
          ...formFields,
          skuShortDescription: getSKUData?.Name,
          skuLongDescription: getSKUData?.Description,
          costCategory: selectedCostCategory?.CostMetricType,
          chargingIncrement: getSKUData?.CostIntervalCd,
          returnable: setValueZeroOrOne(getSKUData?.IsReturnable),
          costMacroCategory: getSKUData?.CostMacroCategoryCd,
          minimumSelectableIncrement: getSKUData?.CostIntervalMin || null,
          cost: validateDecimalValue(getSKUData?.CostMetricCost),
          skuRelation: skuRelationSelected,
          autoProvision: setValueZeroOrOne(getSKUData?.IsAutoProvisioned),
          commercialStatus: commercialStatus?.value,
          costMetric: selectedCostCategory?.CostMetric,
          CostMetricNSR: validateDecimalValue(getSKUData?.CostMetricNSR),
          billingType: getSKUData?.BillingTypeCd || "",
          Indexation: validateDecimalValue(getSKUData?.Indexation),
        };
      });
      setGlobalRiskMng(getEmailList(getSKUData?.GlobalRiskMgr));
      setLocalRiskMng(getEmailList(getSKUData?.LocalRiskMgr));
      setProductApproverList(getEmailList(getSKUData?.ProductApprover));
      setDeploymentApproverList(getEmailList(getSKUData?.DeploymentApprover));
      setConsumptionManagerList(getEmailList(getSKUData?.ConsumptionMgr));
    }
  }, [getSKUData, configData]);

  const handleDownloadArtifact = async () => {
    if (isConsumptionManager) {
      return;
    }
    setArtifactPreviewError("");
    const payload = {
      Action: "downloadskuartifact",
      SkuId: getSKUData.SkuId,
      ArtifactId: getSKUData.LatestArtifactId.toString(),
    };

    try {
      const fileData = await dispatch(fetchSKUArtifactFileData(payload));
      if (fileData && fileData.payload.Status === "success") {
        downloadArtifactFile(fileData.payload.Data);
      } else {
        setArtifactPreviewError(
          "Something went wrong while downloading the CFO approval document.",
        );
      }
    } catch (error) {
      console.error("Error fetching SKU artifact:", error);
      setArtifactPreviewError(
        "Something went wrong while downloading the CFO approval document.",
      );
    }
  };

  if (isconfigLoadingAPi || isSkuListLoadingAPi || getSKUIsLoadingAPi) {
    return <Loader />;
  }
  if (configErrorAPi || getSKUErrorAPi) {
    return <div className="error">Error fetching data</div>;
  }
  if (!configData) {
    return <div className="error">No data available</div>;
  }
  return (
    <div className="create-sku-modal">
      <MotifTheme variant={"light"}></MotifTheme>
      <MotifModal
        className="createSkuModal updateSkuModal previewSkuModal"
        id="UpdateSkuModel"
        show={show}
        onClose={() => {
          setShow(false);
          setFormFields(initialValues);
        }}
        focusTrapOptions={{
          tabbableOptions: {
            displayCheck: "none",
          },
        }}
      >
        <>
          <MotifModalHeader>{"Preview"}</MotifModalHeader>
          <MotifModalBody>
            {(skuListErrorAPi || createSKUErrorAPi) && (
              <>
                <div className="motif-row error-grid">
                  <div className="motif-col-lg-12">
                    <NotificationGrid
                      show={true}
                      message={"Unexpected error occurred while creating SKU"}
                      type="error"
                    />
                  </div>
                </div>
              </>
            )}
            <div className="motif-row heading">
              <div className="motif-col-lg-12">
                <div className="title">SKU Details</div>
              </div>
            </div>
            {artifactPreviewError && (
              <>
                <div className="motif-row error-grid">
                  <div className="motif-col-lg-12">
                    <NotificationGrid
                      show={true}
                      message={artifactPreviewError}
                      type="error"
                    />
                  </div>
                </div>
              </>
            )}
            <div className="motif-row form-item-row single-row">
              <div className="motif-col-lg-2  form-item">
                <div className="label">{EMPIRE_CODE_PLACEHOLDER}:</div>
              </div>
              <div className="motif-col-lg-5  form-item skuNumbertext">
                {`${currentSku}`}
              </div>
            </div>
            <div className="motif-row form-item-row single-row">
              <div className="motif-col-lg-2  form-item">
                <div className="label">{SKU_NAME}:</div>
              </div>
              <div className="motif-col-lg-10  form-item">
                <div className="value">
                  <div className="inputField">{skuShortDescription}</div>
                </div>
              </div>
            </div>
            <div className="motif-row form-item-row single-row">
              <div className="motif-col-lg-2  form-item">
                <div className="label">{SKU_LONG_DESCRIPTION}:</div>
              </div>
              <div className="motif-col-lg-10  form-item">
                <div className="value">
                  <div className="inputField">
                    <div
                      dangerouslySetInnerHTML={
                        skuLongDescription
                          ? {
                              __html: skuLongDescription.replace(
                                /&nbsp;/g,
                                " ",
                              ),
                            }
                          : undefined
                      }
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            {getSKUData?.StatusCd === "Active" && (
              <div className="motif-row form-item-row single-row cfo-approval-row">
                <div className="motif-col-lg-2 form-item">
                  <div className="label">{CFO_APPROVAL}:</div>
                </div>
                <div className="motif-col-lg-10 form-item cfo-approval-section">
                  {getSKUData?.LatestArtifactURL ? (
                    <div
                      className="file-section"
                      onClick={handleDownloadArtifact}
                      style={{
                        cursor: isConsumptionManager ? "default" : "pointer",
                        backgroundColor: isConsumptionManager
                          ? "#f0f0f0"
                          : "transparent",
                      }}
                    >
                      <div className="file-details">
                        <MotifIcon
                          iconFunction={IconoirDownload}
                          size="20"
                          fill="#000"
                        />
                        <div>
                          <div className="file-name">
                            <MotifTooltip
                              contentClassName="tooltip-content"
                              allowHover
                              allowClick={false}
                              id={`tooltip`}
                              placement="auto"
                              trigger={
                                <span
                                  aria-label="Tooltip"
                                  onClick={handleDownloadArtifact}
                                >
                                  {truncateString(
                                    getArtifactFileName(
                                      getSKUData.LatestArtifactURL,
                                    ),
                                    69,
                                  )}
                                </span>
                              }
                              usePortal
                              variant="default"
                              hide={
                                getArtifactFileName(
                                  getSKUData.LatestArtifactURL,
                                ).length <= 69
                              }
                            >
                              {getArtifactFileName(
                                getSKUData.LatestArtifactURL,
                              )}
                            </MotifTooltip>
                          </div>
                          <div className="file-size">
                            {formattingBytes(getSKUData.LatestArtifactFileSize)}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="value no-cfo-approval-title">
                      {NO_CFO_APPROVAL}
                    </div>
                  )}
                </div>
              </div>
            )}
            <div className="motif-row heading costing-label">
              <div className="motif-col-lg-12">
                <div className="title">Costing</div>
              </div>
            </div>
            <div className="motif-row form-item-row double-row">
              <div className="motif-col-lg">
                <div className="motif-row">
                  <div className="motif-col-lg-4 form-item">
                    <div className="label">{COST_CATEGORY}:</div>
                  </div>
                  <div className="motif-col-lg-8 form-item">
                    <div className="value">
                      <div className="inputField">{costCategory}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="motif-col-lg">
                <div className="motif-row right-content">
                  <div className="motif-col-lg-4 form-item">
                    <div className="label">{COST_INTERVAL}:</div>
                  </div>
                  <div className="motif-col-lg-8 form-item">
                    <div className="value">
                      <div className="inputField">
                        {ChargingIncrementOptions.find(
                          (item) => item.value === chargingIncrement,
                        )?.label || ""}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="motif-row form-item-row double-row">
              <div className="motif-col-lg">
                <div className="motif-row">
                  <div className="motif-col-lg-4 form-item">
                    <div className="label">{RETURNABLE}:</div>
                  </div>
                  <div className="motif-col-lg-8 form-item">
                    <div className="value">
                      <div className="inputField">
                        {setValueYesOrNo(returnable) || "-"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="motif-col-lg">
                <div className="motif-row right-content">
                  <div className="motif-col-lg-4 form-item">
                    <div className="label">{COST_MACRO_CATEGORY}:</div>
                  </div>
                  <div className="motif-col-lg-8 form-item">
                    <div className="value">
                      <div className="inputField">
                        {CostMacroCategoryOptions.filter((item) =>
                          costMacroCategory.includes(item.value),
                        )
                          .map((item) => item.label)
                          .join(", ")}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="motif-row form-item-row double-row">
              <div className="motif-col-lg">
                <div className="motif-row">
                  <div className="motif-col-lg-4 form-item">
                    <div className="label">{MINIMUM_SELECTABLE_INCREMENT}:</div>
                  </div>
                  <div className="motif-col-lg-8 form-item">
                    <div className="value">
                      <div className="inputField">
                        {minimumSelectableIncrement || "-"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="motif-col-lg">
                <div className="motif-row right-content">
                  <div className="motif-col-lg-4 form-item">
                    <div className="label">{COST}:</div>
                  </div>
                  <div className="motif-col-lg-8 form-item">
                    <div className="value">
                      <div className="inputField">
                        {`${cost ? `$USD ${formatUSDWithCommas(cost)}` : "-"}`}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="motif-row form-item-row double-row">
              <div className="motif-col-lg hide">
                <div className="motif-row">
                  <div className="motif-col-lg-4 form-item">
                    <div className="label">{SKU_RELATION}:</div>
                  </div>
                  <div className="motif-col-lg-8 form-item">
                    <div className="value">
                      <div className="inputField">
                        {skuRelation.join(", ") || "-"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="motif-col-lg">
                <div className="motif-row right-content">
                  <div className="motif-col-lg-4 form-item">
                    <div className="label">{AUTO_PROVISION}:</div>
                  </div>
                  <div className="motif-col-lg-8 form-item">
                    <div className="value">
                      <div className="inputField">
                        {setValueYesOrNo(autoProvision) || "-"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="motif-col-lg">
                <div className="motif-row">
                  <div className="motif-col-lg-4 form-item">
                    <div className="label">{BILLING_TYPE_STATUS}:</div>
                  </div>
                  <div className="motif-col-lg-8 form-item">
                    <div className="value">
                      <div className="inputField">
                        {BillingTypeOptions.find(
                          (item) => item.label === billingType,
                        )?.label || ""}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="motif-row form-item-row double-row">
              <div className="motif-col-lg">
                <div className="motif-row right-content">
                  <div className="motif-col-lg-4 form-item">
                    <div className="label">{COST_METRIC}:</div>
                  </div>
                  <div className="motif-col-lg-8 form-item">
                    <div className="value">
                      <div className="inputField">{costMetric}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="motif-col-lg">
                <div className="motif-row">
                  <div className="motif-col-lg-4 form-item">
                    <div className="label">{NSR}:</div>
                  </div>
                  <div className="motif-col-lg-8 form-item">
                    <div className="value">
                      <div className="inputField">
                        {CostMetricNSR
                          ? `$USD ${formatUSDWithCommas(CostMetricNSR)}`
                          : "-"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="motif-row form-item-row double-row">
              <div className="motif-col-lg">
                <div className="motif-row">
                  <div className="motif-col-lg-4 form-item">
                    <div className="label">{INDEXATION}:</div>
                  </div>
                  <div className="motif-col-lg-8 form-item">
                    <div className="value">
                      <div className="inputField">
                        {Indexation ? `${Indexation}%` : "-"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="motif-col-lg">
                <div className="motif-row right-content">
                  <div className="motif-col-lg-4 form-item">
                    <div className="label">{COMMERCIAL_STATUS}:</div>
                  </div>
                  <div className="motif-col-lg-8 form-item">
                    <div className="value">
                      <div className="inputField">
                        {CommercialStatusOptions.find(
                          (item) => item.value === commercialStatus,
                        )?.label || ""}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="motif-row heading costing-label">
              <div className="motif-col-lg-12">
                <div className="title">{ORDER_ACKNOWLEDGEMENT}</div>
              </div>
            </div>
            <div className="motif-row form-item-row double-row">
              <div className="motif-col-lg">
                <div className="motif-row">
                  <div className="motif-col-lg-4 form-item label-item">
                    <div className="label">{GLOBAL_RISK_MANAGER}</div>
                  </div>
                  <div className="motif-col-lg-8 form-item">
                    <div className="value">
                      <div className="inputField">{globalRiskMng}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="motif-col-lg">
                <div className="motif-row right-content">
                  <div className="motif-col-lg-4 form-item label-item">
                    <div className="label">{LOCAL_RISK_MANAGER}</div>
                  </div>
                  <div className="motif-col-lg-8 form-item">
                    <div className="value">
                      <div className="inputField">{localRiskMng}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="motif-row form-item-row double-row">
              <div className="motif-col-lg">
                <div className="motif-row">
                  <div className="motif-col-lg-4 form-item label-item">
                    <div className="label">{PRODUCT_APPROVER}</div>
                  </div>
                  <div className="motif-col-lg-8 form-item">
                    <div className="value">
                      <div className="inputField">{productApproverList}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="motif-col-lg">
                <div className="motif-row right-content">
                  <div className="motif-col-lg-4 form-item label-item">
                    <div className="label">{PROVISIONING_TEAM}</div>
                  </div>
                  <div className="motif-col-lg-8 form-item">
                    <div className="value">
                      <div className="inputField">{deploymentApproverList}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="motif-row form-item-row double-row">
              <div className="motif-col-lg">
                <div className="motif-row">
                  <div className="motif-col-lg-4 form-item label-item">
                    <div className="label">{CONSUMPTION_MANAGER}</div>
                  </div>
                  <div className="motif-col-lg-8 form-item">
                    <div className="value">
                      <div className="inputField">{consumptionManagerList}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="motif-col-lg" />
            </div>
          </MotifModalBody>
          <MotifModalFooter>
            <MotifButton
              variant={"secondary"}
              onClick={() => {
                setShow(false);
              }}
            >
              Close
            </MotifButton>
          </MotifModalFooter>
        </>
      </MotifModal>
    </div>
  );
}
